/**
 * What a room is called on a page (§4.21, 2026-09-25 三次拍板): the judge's
 * few words for what its people share. The server never writes an empty
 * name (rooms.js roomName), but a row from before that guard can carry one,
 * and a card, a heading or a bookmark with no text is worse than a plain
 * label. Same fallback as the server's.
 */
export const roomTitle = (name: string | null | undefined): string => (name ?? '').trim() || 'A room';
